export default "__VITE_ASSET__I20xDnAG__"